export enum RecurringGiftStatus {
    Active = 1,
    Cancelled = 2,
    Expired = 3,
    Suspended = 4,
    Terminated = 5,
    Error = 6,
}
